/** M7 work-process pipeline: 15 ordered stages a case moves through. */

export type PipelineStatus =
  | "NOT_STARTED"
  | "IN_PROGRESS"
  | "BLOCKED"
  | "DONE"
  | "SKIPPED";

/** Stage KEY (the PATCH path segment, e.g. BANK_DATA). */
export type PipelineStageKey =
  | "BANK_DATA"
  | "BOOKKEEPING"
  | "RECONCILIATION"
  | "FINANCIAL_STATEMENTS"
  | "TAX_DATA"
  | "TAX_PREP"
  | "REVIEW"
  | "CLIENT_APPROVAL"
  | "ESIGNATURE"
  | "EFILE"
  | "IRS_ACK"
  | "PAYMENT_REFUND"
  | "NOTICE_MONITORING"
  | "REPORTING"
  | "NEXT_YEAR";

export interface PipelineStage {
  id: string;
  /** Stage KEY used in the PATCH path. */
  stage: PipelineStageKey;
  stageLabel: string;
  position: number;
  status: PipelineStatus;
  assignee: number | null;
  assigneeName: string | null;
  notes: string;
  startedAt: string | null;
  completedAt: string | null;
}

/** Body for PATCH /cases/:id/pipeline/:stage/ — all fields optional. */
export interface UpdateStagePayload {
  status?: PipelineStatus;
  assignee?: number | null;
  notes?: string;
}

/** Result of POST /cases/:id/pipeline/roll-forward/ (the opened next-year case). */
export interface RollForwardResult {
  id: string;
  taxYears: string;
}

export const PIPELINE_STATUS_OPTIONS: PipelineStatus[] = [
  "NOT_STARTED",
  "IN_PROGRESS",
  "BLOCKED",
  "DONE",
  "SKIPPED",
];

export const PIPELINE_STATUS_META: Record<
  PipelineStatus,
  { label: string; variant: "secondary" | "default" | "outline" | "destructive" }
> = {
  NOT_STARTED: { label: "Not started", variant: "outline" },
  IN_PROGRESS: { label: "In progress", variant: "secondary" },
  BLOCKED: { label: "Blocked", variant: "destructive" },
  DONE: { label: "Done", variant: "default" },
  SKIPPED: { label: "Skipped", variant: "outline" },
};
